<template>
  <div>
    <v-list-tile
      v-for="(item, index) in items"
      :to="item.to"
      :key="index"
    >
      <v-list-tile-action>
        <v-icon color="indigo">{{ item.action }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        items: [
          {
            action: 'list',
            title: 'Tracking list',
            to: {name: 'dashboard'}
          },
          {
            action: 'assessment',
            title: 'Reports',
            to: {name: 'report-index'}
          }
        ]
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/common/MainMenu.vue